import React, { useEffect, useState } from "react";
import "./LogsAtividades.css";
import { jwtDecode } from "jwt-decode";
import ThemeProvider from "../theme/TemaMuiProvider";
import { Box, Button, TablePagination, TextField } from "@mui/material";
import muiTheme from "../theme/muiTheme";

function LogsAtividades() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [termoBusca, setTermoBusca] = useState("");

  // PAGINAÇÃO (ADICIONADO)

  const [paginaAtual, setPaginaAtual] = useState(1);
  const [logsPorPagina, setLogsPorPagina] = useState(10);

  const indexInicial = (paginaAtual - 1) * logsPorPagina;
  const indexFinal = indexInicial + logsPorPagina;

  // logs filtrados
  const logsPaginados = logs.slice(indexInicial, indexFinal);

  // SISTEMA DE PERMISSÕES

  const token = localStorage.getItem("token");
  let tipoUsuario = "";

  if (token) {
    const decoded = jwtDecode(token);

    tipoUsuario = decoded.tipo
      ?.toString()
      .trim()
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");
  }

  const podeVerLogs = ["administrador"].includes(tipoUsuario);

  // BUSCA LOGS (somente admin)
  const buscarLogs = () => {
    if (!podeVerLogs) return;

    setLoading(true);
    const token = localStorage.getItem("token");

    fetch(`/api/logs/buscar?termo=${encodeURIComponent(termoBusca.trim())}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => res.json())
      .then((data) => {
        setLogs(Array.isArray(data) ? data : []);
        setPaginaAtual(1);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Erro ao buscar logs:", err);
        setLoading(false);
      });
  };

  useEffect(() => {
    if (podeVerLogs) {
      buscarLogs();
    }
  }, []);

  // CASO NÃO TENHA PERMISSÃO
  if (!podeVerLogs) {
    return (
      <ThemeProvider theme={muiTheme}>
        <div className="logs-container">
          <h2>Logs - Atividades</h2>

          <div className="aviso-permissao-container">
            <p className="aviso-permissao">🔒 Acesso restrito ao Administrador.</p>
          </div>
        </div>
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider theme={muiTheme}>
      <div className="logs-container">
        <h2>Logs - Atividades</h2>

        <Box
          sx={{
            display: "flex",
            gap: 1,
            alignItems: "center",
            mb: 2,
            width: "100%",
          }}
        >
          <TextField
            label="Buscar atividades"
            value={termoBusca}
            onChange={(e) => setTermoBusca(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                buscarLogs();
              }
            }}
            fullWidth
            size="small"
          />

          <Button
            variant="outlined"
            onClick={() => {
              setTermoBusca("");
              setTimeout(() => buscarLogs(), 0);
            }}
            sx={{
              height: 40,
              minWidth: 120,
              textTransform: "none",
              fontWeight: 600,
            }}
          >
            Limpar Filtro
          </Button>

          <Button
            variant="contained"
            onClick={buscarLogs}
            sx={{
              height: 40,
              minWidth: 100,
              textTransform: "none",
              fontWeight: 600,
            }}
          >
            Buscar
          </Button>
        </Box>

        {loading ? (
          <p>Carregando registros...</p>
        ) : logs.length === 0 ? (
          <p className="erro">Nenhuma atividade registrada.</p>
        ) : (
          <>
            <ul className="logs-lista">
              {logsPaginados.map((log) => (
                <li key={log.id} className="logs-item">
                  <span className="logs-data">{new Date(log.dataHora).toLocaleString("pt-BR")}</span>
                  <span className="logs-texto">
                    — {log.usuarioNome || `Usuário ${log.usuarioId}`} realizou: {log.descricao || log.acao}
                  </span>
                </li>
              ))}
            </ul>

            {/* PAGINAÇÃO */}
            <TablePagination
              component="div"
              count={logs.length}
              page={paginaAtual - 1}
              onPageChange={(_, novaPagina) => setPaginaAtual(novaPagina + 1)}
              rowsPerPage={logsPorPagina}
              onRowsPerPageChange={(e) => {
                setLogsPorPagina(parseInt(e.target.value, 10));
                setPaginaAtual(1);
              }}
              rowsPerPageOptions={[5, 10, 25]}
              labelRowsPerPage="Logs por página:"
              labelDisplayedRows={({ from, to, count }) => `${from}–${to} de ${count}`}
              sx={{
                fontSize: "0.8rem",
                minHeight: 42,
                color: "var(--ig-t-ffffff)",
                borderTop: "1px solid var(--ig-b-444444)",
                mt: 2,

                "& .MuiTablePagination-toolbar": {
                  minHeight: 42,
                  alignItems: "center",
                },

                "& .MuiTablePagination-spacer": {
                  flex: "1 1 auto",
                },

                "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows": {
                  fontSize: "0.8rem",
                  margin: 0,
                  color: "var(--ig-t-ffffff)",
                },

                "& .MuiTablePagination-select": {
                  color: "var(--ig-t-ffffff)",
                },

                "& .MuiTablePagination-selectIcon": {
                  color: "var(--ig-t-ffffff)",
                },

                "& .MuiTablePagination-menuItem": {
                  fontSize: "0.85rem",
                },

                "& .MuiTablePagination-actions button": {
                  color: "var(--ig-t-ffffff)",
                  width: "auto",
                },

                "& .MuiTablePagination-actions": {
                  display: "flex",
                  alignItems: "center",
                },
              }}
            />
          </>
        )}
      </div>
    </ThemeProvider>
  );
}

export default LogsAtividades;
